import { CREATE, DELETE, DELETE_MANY, fetchUtils, GET_LIST, GET_MANY, GET_MANY_REFERENCE, GET_ONE, UPDATE, UPDATE_MANY, } from 'react-admin';
import { stringify } from 'qs';

function convertRequest(baseUrl, type, resource, params) {
    var url = '';
    var options = {};

    switch (type) {
        case GET_LIST: {
            const { page, perPage } = params.pagination;
            const { field, order } = params.sort;
            const query = {
                sort: JSON.stringify({ [field === 'id' ? getIdFromResource(resource) : field]: order.toLowerCase() }),
                filter: JSON.stringify(params.filter)
            };

            if (perPage < 1000) {
                query.range = JSON.stringify([(page - 1) * perPage, page * perPage - 1]);
            }

            url = `${baseUrl}/${resource}?${stringify(query)}`;
            break;
        }

        case GET_ONE:
            url = `${baseUrl}/${resource}/${params.id}`;
            break;

        case GET_MANY: {
            const query = {
                filter: JSON.stringify({ [getIdFromResource(resource)]: { $in: params.ids } })
            };

            url = `${baseUrl}/${resource}?${stringify(query)}`;
            break;
        }

        case GET_MANY_REFERENCE: {
            const { page, perPage } = params.pagination;
            const { field, order } = params.sort;
            const query = {
                sort: JSON.stringify({ [field === 'id' ? getIdFromResource(resource) : field]: order.toLowerCase() }),
                range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
                filter: JSON.stringify({ ...params.filter, [params.target]: params.id })
            };

            url = `${baseUrl}/${resource}?${stringify(query)}`;
            break;
        }

        case UPDATE: {
            const rights = JSON.parse(localStorage.getItem('rights'));
            const scope = getScopeFromResource(resource);
            const data = getPropertiesWithRights(params.data, scope, rights);

            url = `${baseUrl}/${getUpdateResourceFromData(resource, params.data, params.id)}`;
            options.method = 'PATCH';
            options.body = JSON.stringify(getUpdateData(resource, data));
            break;
        }

        case CREATE:
            url = `${baseUrl}/${getCreateResourceFromData(resource, params.data)}`;
            options.method = 'POST';
            options.body = JSON.stringify(getCreateData(resource, params.data));
            break;

        case DELETE:
            url = `${baseUrl}/${resource}/${params.id}`;
            options.method = 'DELETE';
            break;

        default:
            throw new Error(`Unsupported fetch action type ${type}.`);
    }

    return { url, options };
}

function convertResponse(response, type, resource, params) {
    const { headers, json } = response;

    switch (type) {
        case GET_LIST:
        case GET_MANY:
        case GET_MANY_REFERENCE:
            if (headers.has('Content-Range')) {
                return {
                    data: json.map(x => ({ ...x, id: getIdFromValue(resource, x, params) })),
                    total: parseInt(headers.get('Content-Range').split('/').pop(), 10),
                };
            } else {
                const result = {
                    data: json.map(x => ({ ...x, id: getIdFromValue(resource, x, params) })),
                    total: json.length
                };

                if (params.pagination && params.pagination.perPage === 1000) {
                    for (let i = 0; i < result.data.length; i++) {
                        for (let property in result.data[i]) {
                            if (result.data[i].hasOwnProperty(property)) {
                                if (result.data[i][property] && (result.data[i][property].constructor.name === 'Array' || result.data[i][property].constructor.name === 'Object')) {
                                    delete result.data[i][property];
                                }
                            }
                        }
                    }
                }

                return result;
            }

        case CREATE:
            return { data: { ...params.data, id: getIdFromValue(resource, json, params) } };

        default:
            return { data: { ...json, id: getIdFromValue(resource, json, params) } };
    }
}

function fetchResponse(url, options) {
    const token = localStorage.getItem('token');

    options.headers = new Headers();
    options.headers.set('x-access-token', token);

    return fetchUtils.fetchJson(url, options);
}

function getCreateData(resource, data) {
    const result = JSON.parse(JSON.stringify(data));

    if (resource === 'owners/current/devices') {
        if (result.lora.encryption.mode === 'ABP') {
            result.lora.encryption = { appSKey: result.lora.encryption.appSKey, devAddr: result.lora.encryption.devAddr, nwkSKey: result.lora.encryption.nwkSKey };
        } else {
            result.lora.encryption = { appEui: result.lora.encryption.appEui, appKey: result.lora.encryption.appKey };
        }
    }

    return result;
}

function getCreateResourceFromData(resource, data) {
    switch (resource) {
        case 'owners/current/devices':
            return data.lora.encryption.mode === 'ABP' ? 'owners/current/devices/lora/abp' : 'owners/current/devices/lora/otaa';

        default:
            return resource;
    }
}

function getIdFromResource(resource) {
    switch (resource) {
        case 'owners/current/devices':
            return 'eui';

        case 'networkServers':
        case 'owners':
            return 'name';

        default:
            throw new Error(`Unsupported resource ${resource}.`);
    }
}

function getIdFromValue(resource, data, params) {
    switch (resource) {
        case 'owners/current/devices':
            return data.eui;

        case 'networkServers':
            return data.name;

        case 'owners':
            return params.id === 'current' ? 'current' : data.name;

        default:
            throw new Error(`Unsupported resource ${resource}.`);
    }
}

function getPropertiesWithRights(obj, scope, rights) {
    var properties = {};

    for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
            var propertyNames = property.split('.');
            var propertyScope = scope;

            for (var i = 0; i < propertyNames.length; i++) {
                propertyScope = `${propertyScope}.${propertyNames[i]}`;

                if (rights.indexOf(propertyScope) >= 0) {
                    properties[property] = obj[property];
                } else if (typeof obj[property] === 'object') {
                    var result = getPropertiesWithRights(obj[property], propertyScope, rights);
                    if (Object.getOwnPropertyNames(result).length > 0) {
                        properties[property] = result;
                    }
                }
            }
        }
    }

    return properties;
}

function getScopeFromResource(resource) {
    switch (resource) {
        case 'owners/current/devices':
            return 'device';

        case 'owners':
            return 'owner';

        default:
            throw new Error(`Unsupported resource ${resource}.`);
    }
}

function getUpdateData(resource, data) {
    const result = JSON.parse(JSON.stringify(data));

    if (resource === 'owners/current/devices') {
        delete result.eui;
        delete result.id;
        delete result.subscription;

        if (result.lora) {
            delete result.lora.counters;
            delete result.lora.ts;

            if (result.lora.encryption) {
                delete result.lora.encryption.mode;
            }
        }

        if (result.sipp && result.sipp.destination) {
            result.sipp = { destination: result.sipp.destination };
        } else {
            delete result.sipp;
        }
    }

    return result;
}

function getUpdateResourceFromData(resource, data, id) {
    switch (resource) {
        case 'owners/current/devices':
            return data.lora.encryption.mode === 'ABP' ? `owners/current/devices/${id}/lora/abp` : `owners/current/devices/${id}/lora/otaa`;

        default:
            return `${resource}/${id}`;
    }
}

export default function (baseUrl) {
    return (type, resource, params) => {
        switch (type) {
            case DELETE_MANY: {
                return Promise.all(
                    params.ids.map(id =>
                        fetchResponse(`${baseUrl}/${resource}/${id}`, {
                            method: 'DELETE'
                        }))
                ).then(responses => ({
                    data: responses.map(response => response.json),
                }));
            }

            case UPDATE_MANY: {
                const rights = JSON.parse(localStorage.getItem('rights'));
                const scope = getScopeFromResource(resource);
                const data = getPropertiesWithRights(params.data, scope, rights);

                return Promise.all(
                    params.ids.map(id =>
                        fetchResponse(`${baseUrl}/${resource}/${id}`, {
                            method: 'PATCH',
                            body: JSON.stringify(data)
                        }))
                ).then(responses => ({
                    data: responses.map(response => response.json),
                }));
            }

            default: {
                const { url, options } = convertRequest(baseUrl, type, resource, params);

                return fetchResponse(url, options).then(response =>
                    convertResponse(response, type, resource, params)
                );
            }
        }
    };
};
